var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Experience"},[_c('div',{staticClass:"App-container"},[(_vm.$route.meta.name == 'welcome')?_c('Home'):_vm._e()],1),_c('Header'),(_vm.alert)?_c('Alert'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }